import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Card } from '@core/models/card';
import { ToastService } from '@core/services/toast.service';
import { CourseStatus } from '@core/enums/course-status';

@Component({
  selector: 'prism-card-list',
  templateUrl: './card-list.component.html',
  styleUrl: './card-list.component.scss'
})
export class CardListComponent {
  @Input() dataList: Card[] = [];
  @Input() listName: string = 'default';
  @Input() listLimit: number = 0;
  @Input() isPublic: boolean = false;
  @Output() cardClick = new EventEmitter<Card>();
  CourseStatus = CourseStatus;

  private toastService = inject(ToastService);

  blobImgUrl: SafeResourceUrl = '';

  constructor(private sanitizer: DomSanitizer) {}

  handleClick(card: Card) {
    this.cardClick.emit(card);
  }

  view(card: Card) {
    if (card?.id) {
      this.cardClick.emit(card);
    } else {
      this.toastService.error('Error: Unable to view');
    }
  }

  trackByCardId(index: number, card: Card): number {
    return card.id ?? index;
  }

  getCardAriaLabel(card: Card): string {
    const parts: string[] = [];
    if (card?.status) parts.push(`Course status: ${card.status}`);
    if (card?.title) parts.push(card.title);
    if (card?.summary || card?.description) parts.push(card.summary || card.description || '');
    return parts.join('. ');
  }

  generateUrlWithSasToken(sasToken: string, blobUrl?: string) {
    if (blobUrl && sasToken) {
      const urlWithSasToken = `${blobUrl}${sasToken}`;
      return this.sanitizer.bypassSecurityTrustResourceUrl(urlWithSasToken);
    }

    return ""
  }
}
